import React from "react";

const Container = ({ children, className }) => {
  // Add all classs to an array
  const addAllClasses = ["container m-auto"];
  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  return <div className={addAllClasses.join(" ")}>{children}</div>;
};

export default Container;
